import "./index.css";
import InitRoutes from "./InitRoutes.jsx";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals.js";
import BackgroundSVG from "./components/reusables/BackgroundSVG.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<React.StrictMode>
		<div className='Site-layout'>
			<BackgroundSVG position="top" />
			<InitRoutes />
			<BackgroundSVG position="bottom" />
		</div>
	</React.StrictMode>
);

reportWebVitals();
